import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { STUDY_KPI_TOOLTIP_CONTENTS_MAP } from '@catalogues';
import { KpiKeys, KpiNames, MilestoneName } from '@models';

@Component({
  selector: 'kpi-tooltip',
  templateUrl: './kpi-tooltip.component.html',
  styleUrl: './kpi-tooltip.component.scss'
})
export class KpiTooltipComponent implements OnInit, OnChanges {
  @Input() kpiName!: KpiNames | string;
  @Input() kpiKey!: KpiKeys;
  @Input() keyMilestones?: MilestoneName[];

  tooltipContents!: { description: string; keyMilestones?: MilestoneName[]; thresholds?: string[] };

  ngOnInit() {
    this.loadTooltipContents();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['kpiKey'] || changes['keyMilestones']) {
      this.loadTooltipContents();
    }
  }

  private loadTooltipContents() {
    this.tooltipContents = {
      ...(STUDY_KPI_TOOLTIP_CONTENTS_MAP[this.kpiKey] || {
        description: 'No description available'
      })
    };
    if (this.kpiKey === 'key_milestones_on_track_to_baseline' && this.keyMilestones !== undefined) {
      this.tooltipContents.keyMilestones = this.keyMilestones;
    }
  }
}
